import './style/global.less';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { ConfigProvider } from '@arco-design/web-react';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import axios from 'axios';
import rootReducer from './store';
import PageLayout from './layout';
import { GlobalContext } from './context';
import Login from './pages/login';
import checkLogin from './utils/checkLogin';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import  './style/alicon.css';
import  './style/alicon.js';
import './mock';
import { useLocation } from 'react-router-dom';
//import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
const store = createStore(rootReducer);

localStorage.setItem("systemType", '1'); // 1 海豚 2阿b




function Index() {
    const [lang, setLang] = useStorage('arco-lang', 'zh-CN');
    const [theme, setTheme] = useStorage('arco-theme', 'light');

	
	const url = window.location.href;
	//const url = "https://www.ieh5.com/home/?invite_code=axc";
	const params = new URL(url).searchParams;
	const inviteCode = params.get("invite_code");

	if(inviteCode){
		  const item = {
		    value: inviteCode,
		    expiration: new Date().getTime() + 30 * 24 * 60 * 60 * 1000 // 过期时间为当前时间加上指定天数
		  };
		localStorage.setItem("inviteCode", JSON.stringify(item));
	}
	
  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      case 'en-US':
        return enUS;
      default:
        return zhCN;
    }
  }

  // function fetchUserInfo() {
  //   store.dispatch({
  //     type: 'update-userInfo',
  //     payload: { userLoading: true },
  //   });
  //   axios.get('/home/api/user/userInfo').then((res) => {
  //     store.dispatch({
  //       type: 'update-userInfo',
  //       payload: { userInfo: res.data, userLoading: false },
  //     });
  //   });
  // }

  useEffect(() => {
    if (checkLogin()) {
      // fetchUserInfo();
    } else if (window.location.pathname.replace(/\//g, '') !== 'homelogin') {
	  window.location.pathname = '/home/login';
    }
  }, []);

  useEffect(() => {
    changeTheme(theme);
  }, [theme]);

  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme,
  };

  return (
    <BrowserRouter basename="/home">
      <ConfigProvider
        locale={getArcoLocale()}
        componentConfig={{
          Card: {
            bordered: false,
          },
          List: {
            bordered: false,
          },
          Table: {
            border: false,
          },
        }}
      >
        <Provider store={store}>
          <GlobalContext.Provider value={contextValue}>
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/" component={PageLayout} />
            </Switch>
          </GlobalContext.Provider>
        </Provider>
      </ConfigProvider>
    </BrowserRouter>
  );
}
 
// ReactDOM.render( <ErrorBoundary>
//     <Index />
//   </ErrorBoundary>, document.getElementById('root'));
ReactDOM.render( 
    <Index />
, document.getElementById('root'));